import logo_zagoo from '../assets/images/logo-zagoo.png';
import logo_youdong from '../assets/images/logo-youdong.png';

const Footer = () => {
  return (
    <>
      <div className='contact'>
        <div className='container mx-auto flex flex-col items-center pt-12 pb-8 lg:pt-24 lg:pb-16'>
          <div className='contact-list'>
            <div className='contact-item'>
              <div className='contact-title'>Hỗ Trợ Nhanh Zagoo</div>
              <a
                className='contact-icon icon-contact'
                href='https://hotro.zagoo.vn/#!/login'
                target='_blank'
                rel='noreferrer'
              ></a>
              <div className='contact-label'>
                <div>Đừng Ngại Ngần</div>
                <div>Liên Hệ Ngay Tại Đây</div>
              </div>
            </div>
            <div className='contact-item'>
              <div className='contact-title'>Cộng đồng Zalo</div>
              <a
                className='contact-icon icon-zalo'
                href='https://zalo.me/talavuonglaogiazagoo'
                target='_blank'
                rel='noreferrer'
              ></a>
              <div className='contact-label'>
                <div>Tham Gia Ngay</div>
              </div>
            </div>
            <div className='contact-item'>
              <div className='contact-title'>Cộng đồng Facebook</div>
              <a
                className='contact-icon icon-fb'
                href='https://www.facebook.com/vuonglaogia.zagoo.vn/'
                target='_blank'
                rel='noreferrer'
              ></a>
              <div className='contact-label'>
                <div>Tham Gia Ngay</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='footer'>
        <div className='container mx-auto flex flex-col items-center pt-16 pb-24'>
          <div className='grid grid-cols-2 mb-4'>
            <a className='logo' href='#'>
              <img src={logo_zagoo} alt='Zagoo' />
            </a>
            <a className='logo' href='#'>
              <img src={logo_youdong} alt='Youdong' />
            </a>
          </div>
          <div className='address text-center'>
            <div>Công ty TNHH Giải Trí ZIE</div>
            <div>
              Địa chỉ trụ sở chính: Tầng 17, Tòa Nhà ROX Tower, số 54A Nguyễn Chí Thanh, Phường Láng Thượng,
            </div>
            <div>Quận Đống Đa, Thành phố Hà Nội, Việt Nam</div>
          </div>
          
          <div className='address text-center'>
            <div>
            Quyết định phê duyệt nội dung kịch bản trò chơi điện tử G1 trên mạng số: 861/GP-BTTTT do Bộ Thông tin và Truyền thông cấp ngày 09/05/2022
            <br/>Giấy phép cung cấp dịch vụ trò chơi điện tử G1 trên mạng số: 396/GP-BTTTT do Bộ Thông tin và Truyền thông cấp ngày 24/07/2015
            </div>
          </div>
          <div className='link my-2'>
            <a href='dieu-khoan'>Điều khoản</a>
            <span className='mx-2'>|</span>
            <a href='https://zagoo.vn/complaint'>
              Quy trình khiếu nại
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
